module.exports = __webpack_public_path__ + "static/img/banner-csr-07.7fca2d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-07.jpg
// module id = LA/q
// module chunks = 96